import { Card, createStyles, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { ReactElement } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { Topic } from '../../types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      alignItems: 'center',
      background: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      display: 'flex',
      flexDirection: 'row',
      minHeight: 115,
      padding: theme.spacing(3),
    },
    helpLink: {
      textDecoration: 'none',
    },
    avatar: {
      marginRight: theme.spacing(2),
    },
    icon: {
      maxWidth: 65,
      width: '100%',
      height: 'auto',
      flexShrink: 0,
      alignItems: 'center',
    },
    cardContent: {
      maxWidth: 296,
      textAlign: 'left',
    },
  }),
);
function TopicTile({ topic }: { topic: Topic }): ReactElement | null {
  const classes = useStyles();
  const { url } = useRouteMatch();
  const slug = url.endsWith('/') ? topic.slug : `/${topic.slug}`;
  const topicClass = topic.topicName.replaceAll(' ', '-').toLowerCase();

  const tileContent = () => {
    return (
      <Card variant="outlined" className={classes.container}>
        {topic.topicIcon?.url && (
          <div className={classes.avatar}>
            <img src={topic.topicIcon.url} className={classes.icon} />
          </div>
        )}
        <div className={classes.cardContent}>
          <Typography gutterBottom variant="h4" color="primary">
            {topic.topicName}
          </Typography>
          <Typography color="textSecondary" variant="body2">
            {topic.previewDescription}
          </Typography>
        </div>
      </Card>
    );
  };

  return (
    !!topic && (
      <Grid item xs={12} sm={6} md={4}>
        {topic.externalUrl ? (
          <a className={classes.helpLink} href={topic.externalUrl} target="_blank" rel="noreferrer">
            {tileContent()}
          </a>
        ) : (
          <Link
            to={{ pathname: `${url}${slug}`, state: { topic: topic } }}
            className={clsx(classes.helpLink, topicClass)}
          >
            {tileContent()}
          </Link>
        )}
      </Grid>
    )
  );
}

export { TopicTile };
